import { Component, OnInit, Optional, Inject, ViewChild, OnDestroy } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentMethodComponent } from 'src/app/pos-order/components/payment-method/payment-method.component';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from 'src/app/common/services/formater.service';
import { Subscription } from "rxjs";
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-redeem-loyalty',
  templateUrl: './redeem-loyalty.component.html',
  styleUrls: ['./redeem-loyalty.component.css'],
})
export class RedeemLoyaltyComponent implements OnInit, OnDestroy {
  images = { 
    CROSS: CROSS,
  };
  Currency;
  loyaltyAmt = 0;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  isLoading: boolean = false;
  isPaid: boolean = true;
  isPayLoading: boolean = false;
  userId;
  userForm: FormGroup;
  currentPage = 'otpVerification';
  header = 'Login To Use Loyalty Cashback';
  subHeader = 'Enter mobile number and OTP send on it.';
  user = 0;
  otpText = 'SEND OTP';
  enable: boolean = false;
  otp;
  payValue = 0;
  name = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '7vw',
      height: '7vh',
    },
  };

  translationText;
  subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<PaymentMethodComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private curr: CurrencyService,
    private translateService: TranslateService,
    public format: FormaterService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.Currency = this.curr.getCurrency();
  }

  ngOnInit() {
    this.subscription.add(this.translateService.get(['REDEEM_LOYALTY']).subscribe((res) => {
      this.translationText = res.REDEEM_LOYALTY;
      this.header = this.translationText.LOGIN_TO_USE_LC;
      this.subHeader = this.translationText.ENTER_MOBILE_OTP;
      this.otpText = this.translationText.SEND_OTP;
    }));
    this.userForm = this.fb.group({
      dialCode: [localStorage.getItem('pos_dial_code'), [Validators.required]],
      number: [null, [Validators.required]],
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  setVal(val) {
    this.ngOtpInput.setValue(val);
  }
  nextClicked() {
    this.generateToken();
    if (this.user === 1) {
      this.currentPage = 'signup';
      this.header = this.translationText.USER_NOT_EXIST;
      this.subHeader = this.translationText.ENTER_USER_NAME;
    } else if (this.user === 2) {
      this.currentPage = 'cashback';
      this.header = this.translationText.PAY_USING_LC;
      this.subHeader = this.translationText.USE_LC_TO_PAY_BILL;
    }
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  onOtpChange(otpValue) {
    this.otp = otpValue;
    if (otpValue.length === 6) {
      this.verifyOtp();
    }
  }
  saveClicked() {
    this.user = 2;
    this.header = this.translationText.PAY_USING_LC;
    this.subHeader = this.translationText.USE_LC_TO_PAY_BILL;
    this.registerUser();
  }

  sendOtp() {
    this.otpText = this.translationText.RESEND_OTP;
    const formValue = this.userForm.value;
    this.apiService
      .sendOtp({ dial_code: formValue.dialCode, phone: formValue.number })
      .subscribe(
        (res) => {
          if (res?.status === 1) {
            this.messageService.showSuccess(this.translationText.OTP_SUCCESS);
          } else {
            this.messageService.showError(res?.message);
          }
        },
        (error) => {
          this.messageService.showError(this.otpErrorMessage(error));
        },
      );
  }
  verifyOtp() {
    this.otpText = this.translationText.RESEND_OTP;
    const formValue = this.userForm.value;
    this.apiService
      .verifyOtp({
        dial_code: formValue.dialCode,
        phone: formValue.number,
        otp: this.otp,
      })
      .subscribe(
        (res) => {
          if (res?.status === 1) {
            this.messageService.showSuccess(res?.message);
            this.enable = true;
          } else {
            this.messageService.showError(res?.message);
            this.enable = false;
          }
        },
        (error) => {
          this.enable = false;
          this.messageService.showError(this.otpErrorMessage(error));
        },
      );
  }
  otpErrorMessage(error): string {
    const message = error?.error?.message;
    if (Array.isArray(message)) {
      return message.join(', ');
    }
    return message || 'Invalid Request';
  }

  generateToken() {
    const formValue = this.userForm.value;
    this.apiService
      .generateToken({
        dial_code: formValue.dialCode,
        phone: formValue.number,
        otp: this.otp,
      })
      .subscribe((res) => {
        if (res?.status === 1) {
          this.user = 2;
          this.currentPage = 'cashback';
          this.header = this.translationText.PAY_USING_LC;
          this.subHeader = this.translationText.USE_LC_TO_PAY_BILL;
          this.authenticateToken(res?.data?.token);
        } else if (res?.status === 2) {
          this.messageService.showError(this.translationText.NOT_EXISTING_USER);
          this.user = 1;
          this.currentPage = 'signup';
          this.header = this.translationText.USER_NOT_EXIST;
          this.subHeader = this.translationText.ENTER_USER_NAME;
        } else {
          this.messageService.showError(res?.message);
        }
      });
  }
  registerUser() {
    const formValue = this.userForm.value;
    this.apiService
      .registerUser({
        dial_code: formValue.dialCode,
        phone: formValue.number,
        name: this.name,
        otp: this.otp,
      })
      .subscribe((res) => {
        if (res?.status === 1) {
          this.messageService.showSuccess(this.translationText.ACCOUNT_VERIFIED);
          this.authenticateToken(res?.data?.token);
        } else {
          this.messageService.showError(res?.message);
        }
      });
  }
  authenticateToken(token) {
    const param = new FormData();
    param.append('token', token);
    this.apiService.authToken(param).subscribe((res) => {
      if ((res || {}).status === 1) {
        this.messageService.showSuccess(this.translationText.USER_AUTHENTICATED);
        this.userId = (res.data || {}).user_id;
        this.getWallet();
      } else if ((res || {}).status === 0) {
        this.messageService.showError((res || {}).message);
      }
    });
  }
  getWallet() {
    this.isPayLoading = false;
    this.apiService
      .getWallet(this.userId, localStorage.getItem('restaurant_id'))
      .subscribe((res) => {
        if ((res || {}).statusCode === 200) {
          this.loyaltyAmt = (res.data || {}).total_credits || 0;
          if (this.data.amount > (res.data || {}).total_credits) {
            this.payValue = (res.data || {}).total_credits;
          } else {
            this.payValue = this.data.amount;
          }
          this.isPayLoading = true;
        } else {
          this.messageService.showError(this.translationText.SOMETHING_WENT_WRONG);
          this.isPayLoading = true;
        }
      });
  }
  payViaLoyalty() {
    this.isPaid = false;
    let payload = {
      order_id: this.data.id,
      rest_id: localStorage.getItem('restaurant_id'),
      redeem_amount: +this.format.formatMy(this.payValue),
      user_id: this.userId,
    };
    this.apiService.payUsingLoyalty(payload).subscribe(
      (res) => {
        console.log(res);
        this.isPaid = true;
        this.messageService.showSuccess(this.translationText.PAID_SUCCESS);
        this.dialogRef.close({
          success: 1,
          message: 'loyalty_applied',
        });
      },
      (error) => {
        this.messageService.showError(
          this.translationText.SOMETHING_WENT_WRONG || error.error.message
        );
        this.isPaid = true;
      }
    );
  }
}
